import { Bookmark } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'

interface ResourceTagsEmptyProps {
  onCreateClick: () => void
  hasSearch?: boolean
}

export function ResourceTagsEmpty({ onCreateClick, hasSearch }: ResourceTagsEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="mb-4 rounded-full bg-muted p-3">
        <Bookmark className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="mb-1 text-lg font-medium">
        {hasSearch ? 'No matching data classifications' : 'No data classifications yet'}
      </h3>
      <p className="mb-4 max-w-sm text-sm text-muted-foreground">
        {hasSearch
          ? 'Try a different search, or create a new classification.'
          : 'Map application field values to semantic classifications used in policies.'}
      </p>
      {!hasSearch && (
        <Button onClick={onCreateClick}>
          <Plus className="mr-2 h-4 w-4" />
          Create your first classification
        </Button>
      )}
    </div>
  )
}
